module.exports = __webpack_public_path__ + "img/5.579da69d.png";